import React, { useState } from 'react';
import { Card, Container, Button, Modal, Alert } from 'react-bootstrap';
import PasswordResetForm from './PasswordResetForm';

const EnterpriseUserProfile = ({ user }) => {
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  if (!user) return null;
  console.log('Rendering EnterpriseUserProfile with user:', user);
  return (
    <Container className="mt-4">
      {successMessage && (
        <Alert
          variant="success"
          dismissible
          onClose={() => setSuccessMessage('')}
          className="mb-3"
        >
          <i className="bi bi-check-circle me-2"></i>
          {successMessage}
        </Alert>
      )}

      <Card className="mx-auto" style={{ maxWidth: 520 }}>
        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
          <div>
            <i className="bi bi-person-circle me-2"></i>
            User Profile
          </div>
          <Button
            variant="outline-light"
            size="sm"
            onClick={() => setShowPasswordModal(true)}
          >
            <i className="bi bi-key me-1"></i>
            Change Password
          </Button>
        </Card.Header>
        <Card.Body>
          <h5 className="mb-3">{user.name}</h5>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>User ID:</strong> {user.user_account_id}</p>
          <p><strong>Is Person:</strong> {user.is_person ? 'Yes' : 'No'}</p>
          <p><strong>Created At:</strong> {user.created_at ? new Date(user.created_at).toLocaleString() : '-'}</p>
          <p><strong>Last Updated At:</strong> {user.last_updated_at ? new Date(user.last_updated_at).toLocaleString() : '-'}</p>
          <p><strong>Last Updated By:</strong> {user.last_updated_by}</p>
          <hr />
          <h6>Assigned Roles</h6>
          {user.roles && user.roles.length > 0 ? (
            <ul>
              {user.roles.map(role => (
                <li key={role.id}><strong>{role.name}</strong> <span className="text-muted">({role.code})</span></li>
              ))}
            </ul>
          ) : (
            <p className="text-muted">No roles assigned.</p>
          )}
          <hr />
          <h6>Last Login</h6>
          {user.last_login ? (
            <>
              <p><strong>Timestamp:</strong> {user.last_login.attempt_timestamp ? new Date(user.last_login.attempt_timestamp).toLocaleString() : '-'}</p>
              <p><strong>IP Address:</strong> {user.last_login.ip_address || '-'}</p>
              <p><strong>User Agent:</strong> {user.last_login.user_agent || '-'}</p>
              <p><strong>Result:</strong> {user.last_login.attempt_result}</p>
              <p><strong>Session ID:</strong> {user.last_login.session_id || '-'}</p>
            </>
          ) : (
            <p className="text-muted">No login information available.</p>
          )}
          <hr />
          <h6>Session Info</h6>
          {user.login_clearance ? (
            <>
              <p><strong>Logout Timestamp:</strong> {user.login_clearance.logout_timestamp ? new Date(user.login_clearance.logout_timestamp).toLocaleString() : '-'}</p>
              <p><strong>Session Duration (min):</strong> {user.login_clearance.session_duration_minutes || '-'}</p>
              <p><strong>Active:</strong> {user.login_clearance.is_active ? 'Yes' : 'No'}</p>
              <p><strong>Last Activity:</strong> {user.login_clearance.last_activity_timestamp ? new Date(user.login_clearance.last_activity_timestamp).toLocaleString() : '-'}</p>
            </>
          ) : (
            <p className="text-muted">No session information available.</p>
          )}
        </Card.Body>
      </Card>

      {/* Change Password Modal */}
      <Modal
        show={showPasswordModal}
        onHide={() => setShowPasswordModal(false)}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="bi bi-key me-2"></i>
            Change Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div style={{ minHeight: '400px' }}>
            <PasswordResetForm
              user={user}
              isModal={true}
              onPasswordChanged={() => {
                setShowPasswordModal(false);
                setSuccessMessage('Password changed successfully!');
                // Auto-hide the success message after 5 seconds
                setTimeout(() => setSuccessMessage(''), 5000);
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default EnterpriseUserProfile;
